import React from 'react';
import { DualColumnCard } from './dual-colum-card';
import { IUserDetail, SearchWord, TArticleDetail, TComment } from 'shared/models';

import './style.scss';

export type TSimpleDualColumnCardInfo = {
  article: TArticleDetail;
  author: IUserDetail;
  comments: TComment[];
};

interface DualColumnGalleryProps {
  cards: TSimpleDualColumnCardInfo[];
  words: SearchWord[];
}

export const SimpleDualColumnGallery: React.FC<DualColumnGalleryProps> = ({ cards, words }) => {
  return (
    <div className="dual-column-gallery-container">
      <div className="dual-column-gallery">
        {cards.map((cardInfo, index) => (
          <DualColumnCard key={`dual-column-card-${index}`} cardInfo={cardInfo} words={words} pos={index} />
        ))}
      </div>
    </div>
  );
};
